export enum BiFormSubmissionStatus {
  INIT = 'INITIATE_SUBMISSION',
  VALIDATION_FAILURE = 'VALIDATION_FAILURE',
  FAILURE = 'FAILURE',
  SUCCESS = 'SUCCESS',
}
